<template>
    <div class="page">
        <div class="grid-container"  v-if="stagedCandidateForm && stagedCandidate">
            <div class="grid margin-on-medium">
                <div class="cell large-12 medium-12 small-12 margin-ignore">
                    <a href="" class="back-cta cta-link" @click.prevent="backButton">
                        <div class="icon left"><SvgArrowLeft fill="primary"/></div>
                        <span>Back</span>
                    </a>
                </div>
                
                <div class="cell large-4 medium-12 small-12">
                    <h2>Candidate details</h2>
                    <hr/>
                    <SelectedRecord v-on:reselect="openDuplicateModal" />
                    <hr/>
                    <div id="staged-candidate">
                        <InputSelectSrcToggle label="Salutation" :field="stagedCandidateForm.fields.salutation" :options="salutations" :src="stagedCandidate.salutation" />
                        <InputFieldSrcToggle label="Forename" type="text" :field="stagedCandidateForm.fields.forename" :src="stagedCandidate.forename" />
                        <InputFieldSrcToggle label="Surname" type="text" :field="stagedCandidateForm.fields.surname" :src="stagedCandidate.surname" />
                        <InputSelectSrcToggle label="Language" :field="stagedCandidateForm.fields.language" :options="languages" :src="stagedCandidate.language" />
                        <InputFieldSrcToggle label="Email" type="email" :field="stagedCandidateForm.fields.email" :src="stagedCandidate.email" @onChange="updateDuplicateList" />
                        <InputFieldSrcToggle label="Telephone" type="tel" :field="stagedCandidateForm.fields.telephone" :src="stagedCandidate.telephone" />
                        <InputFieldSrcToggle label="Mobile" type="tel" :field="stagedCandidateForm.fields.mobile" :src="stagedCandidate.mobile" />
                        <InputSelectSrcToggle label="Country" :field="stagedCandidateForm.fields.country" :options="countries" :src="stagedCandidate.country" @onChange="updateProvinceOptions"/>
                        <InputFieldSrcToggle label="Street" type="text" :field="stagedCandidateForm.fields.street" :src="stagedCandidate.street" />
                        <InputFieldSrcToggle label="City" type="text" :field="stagedCandidateForm.fields.city" :src="stagedCandidate.city" />
                        <InputSelectSrcToggle label="Province" :field="stagedCandidateForm.fields.province" :options="currentProvinces" :src="stagedCandidate.province" v-if="currentProvinces.length > 0" />
                        <InputFieldSrcToggle label="Postal Code" type="text" :field="stagedCandidateForm.fields.postalCode" :src="stagedCandidate.postalCode" />
                        <InputFieldSrcToggle label="Current Job Title" type="text" :field="stagedCandidateForm.fields.jobTitle" :src="stagedCandidate.jobTitle" />
                        <InputSelect label="Employment Type" :field="stagedCandidateForm.fields.employmentType" :options="employmentType" />
                        <InputSelect label="Brand" :field="stagedCandidateForm.fields.brand" :options="brands" :disabled="true" /> <!-- externalId != null -->
                        <InputSelect label="Cv Source" :field="stagedCandidateForm.fields.cvSource" :options="cvSources"  :disabled="true" :flexibleOptions="true" />

                        <div class="api-error" v-if="updateError|| commitError">
                            <p>There was a problem with your request:</p>
                            <p>{{updateError ? updateError : commitError}}</p>
                        </div>

                        <div class="button-container text-right">
                            <a href="" class="button hollow" id="update-candidate-button" @click.prevent="sendCandidate(false)"
                               :class="{disabled:isOccupied || !stagedCandidateForm.hasChanged}">Save for later</a>
                            <a href="" class="button" id="send-candidate-button" @click.prevent="sendCandidate(true)"
                               :class="{disabled:isOccupied}">Update</a>
                        </div>
                    </div>
                </div>
                <div class="cell large-8 medium-12 small-12">

                    <div class="title-with-button">
                        <h2>Candidate CV</h2>
                        <div class="button-list" v-if="jobLink">
                            <a :href="jobLink" class="button" target="_blank" id="view-job-button">View Job</a>
                        </div>
                    </div>
                        
                    <div id="normalised-cv" v-if="normalisedCv">
                        <section class="cv-section" v-for="(section, index) in normalisedCv.sections" :key="index">
                            <h3>{{section.title}}</h3>
                            <p v-html="section.text"></p>
                        </section>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {getStagedCandidate, getStagedCandidateCv, updateStagedCandidate} from "../../apis/sthree.consultant.api"

    import SelectedRecord from './SelectedRecord';
    import InputFieldSrcToggle from '../core/inputs/InputFieldSrcToggle';
    import InputSelectSrcToggle from '../core/inputs/InputSelectSrcToggle';
    
    import InputSelect from '../vue-components/src/components/core/inputs/InputSelect';

    import SvgArrowLeft from '../vue-components/src/components/core/icons/SvgArrowLeft';

    import cssVars from 'css-vars-ponyfill';


    //const LIGHTNING_THEME = 'theme4d';

    export default {
        name: "StagedCandidate",
        components: {SelectedRecord, InputSelect, InputFieldSrcToggle, InputSelectSrcToggle, SvgArrowLeft},
        async created() {
            
            this.$store.dispatch('startFetch');
            
            await this.fetchStagedCandidate();
            
            if(this.scFetched) {
                this.$store.commit('setStagedCandidateDuplicates',[]);
                if (this.canFetchDuplicates) {
                    await this.fetchStagedCandidateDuplicates();
                    await this.$store.dispatch('generateStagedCandidateDiffs', this.stagedCandidate);
                }
                await this.fetchStagedCandidateCv();

                if (this.selectedCountry) {
                    await this.$store.dispatch('lookup', {type: 'Province', parentId: this.selectedCountry});
                    if (this.currentProvinces.length === 0) {
                        this.stagedCandidateForm.fields.province.value = '';
                    }
                }

                if(this.stagedCandidateDiff){
                    this.handleProvince();
                    this.handleLanguage();
                }

                this.$store.dispatch('endFetch');
                
                if(this.stagedCandidateForm.fields.email.value){
                    this.checkDuplicates(false);
                }
                

            } else {
                this.$store.dispatch('endFetch');
            }

            cssVars();

        },
        computed: {
            sendCandidateFlag() {
                return this.$store.state.cvUpload.sendCandidateFlag;
            },
            externalId() {
                return this.$route.query.externalId != '' ? this.$route.query.externalId : null;
            },
            isOccupied() {
                return this.$store.state.activity.fetching || this.$store.state.activity.uploading
            },
            stagedCandidate() {
                return this.$store.state.cvUpload.stagedCandidate;
            },
            stagedCandidateForm() {
                return this.$store.state.cvUpload.stagedCandidateForm;
            },
            stagedCandidateDuplicates() {
                return this.$store.state.cvUpload.stagedCandidateDuplicates;
            },
            stagedCandidateDiff() {
                return this.$store.state.cvUpload.stagedCandidateDiff;
            },
            backRoute() {
                return this.externalId ? {
                    path: './',
                    query: {
                        externalId: this.externalId
                    }
                } : {
                    path: './'
                };

            },
            environment() {
                return this.$store.state.app.environment || '';
            },
            theme() {
                return this.$store.state.user.theme || '';
            },
            countries() {
                return this.$store.state.app.lookup['Country'] || [];
            },
            provinces() {
                return this.$store.state.app.lookup['Province'];
            },
            languages() {
                return this.$store.state.app.lookup['SpokenLanguage'] || [];
            },
            salutations() {
                return this.$store.state.app.lookup['Salutation'] || [];
            },
            cvSources() {
                return this.$store.state.app.lookup['CvSources'] || [];
            },
            brands() {
                return this.$store.state.app.lookup['Brand'] || [];
            },
            employmentType() {
                return this.$store.state.app.lookup['EmploymentType'] || [];
            },
            selectedCountry() {
                if(this.$store.state.cvUpload.stagedCandidateForm){
                    return this.$store.state.cvUpload.stagedCandidateForm.fields.country.value;
                }
                return null;
            },
            currentProvinces() {
                if(this.selectedCountry && this.provinces && this.provinces[this.selectedCountry]){
                    return this.provinces[this.selectedCountry];
                } else {
                    return [];
                }
            },
            sfLink() {
                return this.generateSfLink(this.stagedCandidateForm.externalId);
            },
            canFetchDuplicates(){
                return this.stagedCandidateForm.fields.brand.value && this.stagedCandidateForm.fields.email.value;
            },
            errors() {
                return this.$store.state.app.lookupErrors ||
                    this.$store.state.user.brandsErrors ||
                    this.$store.state.cvUpload.stagedCandidatesErrors ||
                    this.$store.state.cvUpload.normalisedCvErrors;
            },
            updateError() {
                return this.$store.state.cvUpload.updateCandidateErrors;
            },
            commitError() {
                return this.$store.state.cvUpload.commitCandidateErrors;
            },
            jobLink() {
                let url = this.environment;
                let id = this.stagedCandidateForm.fields.forJobId.value;

                if(id) {
                    if (this.theme === 'lightning') {
                        url += '/lightning/r/Job/' + id + '/view?0.source=alohaHeader';
                    } else {
                        url += '/apex/JobView?id=' + id;
                    }
                    return url;
                }
                return '';
            }
        },
        data: function() {
            return {
                normalisedCv: null,
                scFetched: false
            }
        },
        watch: {
            sendCandidateFlag() {
               this.sendCandidate(true);
            }
        },
        methods: {
            async fetchStagedCandidate() {
                this.scFetched = false;
                return this.$store.dispatch('fetchStagedCandidate', this.$route.params.id)
                .then(() => {
                    this.scFetched = true;
                })
                .catch((error) => {
                    this.$store.dispatch('openMessageBox', {
                        message: 'Unable to load Candidate.',
                        code: (error.responseStatus ? error.responseStatus.message : error),
                        okayText: 'Return to CV Upload',
                        okayFunction: () => {
                            this.$router.push(this.backRoute);
                        }
                    });
                });
            },
            async fetchStagedCandidateDuplicates() {
                const toSend = Object.assign({}, this.stagedCandidateForm.values());
                return this.$store.dispatch('fetchStagedCandidateDuplicates', toSend)
                .catch((error) => {
                    this.$store.dispatch('openMessageBox', {
                        message: 'Unable to load Candidate.',
                        code: (error.responseStatus ? error.responseStatus.message : error),
                        okayText: 'Return to CV Upload',
                        okayFunction: () => {
                            this.$router.push(this.backRoute);
                        }
                    });
                });
            },
            async fetchStagedCandidateCv() {
                return getStagedCandidateCv(this.$route.params.id)
                .then((value) => {
                    this.normalisedCv = value.normalisedCv;
                })
                .catch((error) => {
                    this.$store.dispatch('openMessageBox', {
                        message: 'Unable to load CV.',
                        code: (error.responseStatus ? error.responseStatus.message : error),
                        okayText: 'Return to CV Upload',
                        okayFunction: () => {
                            this.$router.push(this.backRoute);
                        }
                    });
                });
            },
            generateSfLink(externalId){
                let url = this.environment;
                if (this.theme === 'lightning') {
                   url += '/lightning/r/Contact/' + externalId + '/view?0.source=alohaHeader';
                }  else {
                   url += '/apex/ContactView?id=' + externalId;
                }
                return url;
            },
            handleProvince(){
                if(!this.stagedCandidateForm.fields.province) return;

                var currentFormProvince = this.stagedCandidateForm.fields.province.initialValue;
                if( this.currentProvinces.length !== 0 && !this.currentProvinces.filter(e => e.value === currentFormProvince).length > 0){

                    if(this.stagedCandidateDiff.province && this.currentProvinces.filter(e => e.value === this.stagedCandidateDiff.province.sf).length > 0){
                            this.stagedCandidateForm.fields.province.value = this.stagedCandidateDiff.province.sf;
                             this.stagedCandidateForm.fields.province.initialValue = this.stagedCandidateDiff.province.sf;
                     }
                     else{
                        this.stagedCandidateForm.fields.province.value = "";
                        this.stagedCandidateForm.fields.province.initialValue = "";
                    }
                            
                    delete this.stagedCandidateDiff.province;
                }
            },
            handleLanguage(){
                
                if(!this.stagedCandidateForm.fields.language) return;

                var currentFormLang = this.stagedCandidateForm.fields.language.initialValue;
                if(this.languages.length !==0 && !this.languages.filter(e => e.value === currentFormLang).length > 0){
                    if(this.stagedCandidateDiff.language && this.languages.filter(e => e.value === this.stagedCandidateDiff.language.sf).length > 0){
                        this.stagedCandidateForm.fields.language.value = this.stagedCandidateDiff.language.sf;
                        this.stagedCandidateForm.fields.language.initialValue = this.stagedCandidateDiff.language.sf;
                    }
                    else{
                        this.stagedCandidateForm.fields.language.value = "";
                        this.stagedCandidateForm.fields.language.initialValue = "";
                    }
                            
                    delete this.stagedCandidateDiff.language;
                }
            },
            checkDuplicates(inputChange) {
                // inputChange should be set to true, if the user has manually changed the email field
                if (Object.keys(this.stagedCandidateDuplicates).length > 0){
                    if (!this.stagedCandidateForm.fields.forCandidateId.value) {
                        this.openDuplicateModal();
                    } else if (Object.keys(this.stagedCandidateDiff).length > 0) {
                        this.$store.dispatch('openModal', {
                            componentName: 'Diff'
                        });
                    }
                } else {
                    // No Existing record found.
                    if (!inputChange && Object.keys(this.stagedCandidateDiff).length > 0) {
                        // The user has uploaded a CV with a different email address
                        // InputChange varifies that the user _hasn't_ manually changed the email field, as in that instance, the diff screen should NOT display if no matching record is found
                        this.$store.dispatch('openModal', {
                            componentName: 'Diff'
                        });
                    }
                }

            },
            openDuplicateModal(){
                if(this.stagedCandidateForm){
                    this.$store.dispatch('openModal', {
                        componentName: 'DuplicateCandidates',
                        componentProps: {
                        }
                    });
                }
            },
            async updateDuplicateList() {
                if (!this.externalId) {
                    if (this.stagedCandidateForm.fields.forCandidateId.value !== '') {
                        this.$store.dispatch('alert', 'Email changed - Candidate has been unlinked.');
                    }
                    this.$store.commit('unlinkExternalId');
                    if (this.canFetchDuplicates) {
                        this.stagedCandidateForm.fields.email.validate();
                        if(this.stagedCandidateForm.fields.email.validation.error === null){
                            await this.fetchStagedCandidateDuplicates();
                            this.checkDuplicates(true);
                        }
                    }
                }
            },
            updateProvinceOptions(field) {
                this.$store.dispatch('lookup', {type: 'Province', parentId: field.value});
                this.stagedCandidateForm.fields.province.value = '';
            },
            async sendCandidate(commit, returnToBackRoute){
                if(this.stagedCandidateForm.validate()){
                    const self = this;
                    this.$store.dispatch('startUpload');
                    let toSend = Object.assign({}, this.stagedCandidateForm.values());

                    //Search lookup and append country label from lookup to accomodate garbage values from SF
                    for (let i = 0; i < this.countries.length; i++) {
                        if (this.countries[i].value === toSend.country){
                            toSend['countryName'] = this.countries[i].label;
                            break;
                        }
                    }

                    return  updateStagedCandidate(toSend, commit)
                    .then(async (value) => {
                        let sfLink = this.generateSfLink(value.externalId);
                        this.$store.dispatch('endUpload');

                        this.$store.dispatch('startFetch');
                        await this.fetchStagedCandidate();
                        if(this.scFetched && this.canFetchDuplicates) {
                            await this.fetchStagedCandidateDuplicates();
                        }
                        this.$store.dispatch('endFetch');
                        if (commit) {
                            this.$router.push(this.backRoute);
                            this.$store.dispatch('alert', 'Candidate commited.');

                            this.$store.dispatch('openMessageBox', {
                                message: 'Candidate successfully updated. To add codes, please click through to the Candidate record below.',
                                okayText: 'Add another CV',
                                okayFunction: () => {
                                  if(self.externalId){
                                    const url = window.location.href.replace(/externalId=([^&]*)/g,"").replace(/\?\&/g,"?");
                                    window.location.href = url;
                                    this.$router.go();
                                  }
                                },
                                cancelText: 'View candidate',
                                cancelFunction: () => {
                                    window.open(sfLink, "_top");
                                },
                                confirmBox: true
                            });


                        } else {
                            if (returnToBackRoute) {
                                this.$router.push(this.backRoute);
                            } else {
                                window.scrollTo(0,0);
                            }
                            this.$store.dispatch('alert', 'Candidate saved.');
                        }
                            
                    })
                    .catch((error) => {
                        this.$store.dispatch('endUpload');
                        let msg = ''
                        if (commit) {
                            msg = 'Candidate failed to commit.';
                        } else {
                            msg = 'Candidate failed to update.';
                        }
                        this.$store.dispatch('openMessageBox', {
                            message: msg,
                            code: (error.responseStatus ? error.responseStatus.message : error),
                            okayText: 'Continue',
                            okayFunction: () => {
                            }
                        });
                    });
                } else {
                    const self = this;
                    setTimeout(function(){ 
                        //Slight delay to let other transitions and effects settle.
                        if (document.querySelectorAll('.input-wrap.error')[0]) {
                            window.scrollTo(0,document.querySelectorAll('.input-wrap.error')[0].offsetTop);
                        }
                        self.$store.dispatch('alert', 'Errors in staged candidate form. Please review and try again.');
                    }, 30);
                }
            },
            backButton() {
                if (!this.stagedCandidateForm.hasChanged) {
                    this.$router.push(this.backRoute)
                } else {
                    const self = this;
                    this.$store.dispatch('openMessageBox', {
                        message: 'Would you like to save your changes before going back?',
                        confirmBox: true,
                        okayText: 'Save changes',
                        okayFunction: () => {
                            self.sendCandidate(false, true);
                        },
                        cancelText: 'Do not save',
                        cancelFunction: () => {
                            self.$router.push(this.backRoute);
                        }
                    });
                }
            }
        }
    }
</script>

<style scoped>
    #staged-candidate {margin-top: -.5rem;}
    #normalised-cv {white-space: pre-wrap; word-wrap: break-word; background: #fff; padding: 1rem; margin: calc(1.5rem - 1px) 1px 1px 1px; box-shadow: 0 0 0 1px #808080;}
    .cv-section + .cv-section {margin-top: 2rem;}
    .back-cta {margin-bottom: .5rem;}
    .changed { background-color: #93c57a; }
</style>